// Shell — overall page chrome. Sidebar (left fixed rail) + Topbar
// (sticky breadcrumb + actions) + scrollable main content. Replaces the
// prior horizontal CustomerNav/OperatorNav setup.

import { useState } from 'react';
import { type SessionInfo } from '../lib/api.js';
import { Sidebar } from '../components/Sidebar.js';
import { Topbar, TopbarActionsProvider } from '../components/Topbar.js';

interface ShellProps {
  session: SessionInfo;
  children: React.ReactNode;
}

export function Shell({ session, children }: ShellProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <TopbarActionsProvider>
      <div className="min-h-screen bg-zinc-950 text-cream flex">
        <Sidebar
          session={session}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        <div className="flex-1 min-w-0 flex flex-col">
          <Topbar onMobileToggle={() => setMobileOpen((v) => !v)} />
          <main className="flex-1 px-6 lg:px-10 py-10 max-w-[1400px] w-full">
            {children}
          </main>
          <footer className="px-6 lg:px-10 py-5 border-t border-cream/[0.05]">
            <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.16em] text-cream/45">
              <span>businessisbloomin.com</span>
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400/80 animate-pulse" />
                Live
              </span>
            </div>
          </footer>
        </div>
      </div>
    </TopbarActionsProvider>
  );
}
